const ja = {
  pleaseEnterUsername: "ユーザー名を入力してください",
  cannotFriendYourself: "自分自身にフレンドリクエストを送信することはできません。",
  friendRequestSent: "フレンドリクエストを送信しました！",
  failedToSendRequest: "リクエストの送信に失敗しました",
  linkCopied: "リンクをクリップボードにコピーしました！",
  backToInvites: "招待一覧に戻る",
  sendFriendRequestByUsername: "ユーザー名でフレンドリクエストを送信",
  enterUsername: "ユーザー名を入力",
  send: "送信",
  yourInviteQrCode: "あなたの招待QRコード",
  inviteLink: "招待リンク",
  scanQrOrUseLink: "このQRコードをスキャンするか、このリンクを使用してフレンドリクエストを送信してください",
  copyInviteLink: "招待リンクをコピー",
  goToItem: "項目へ移動",
  verificationEmailSent: "確認メールを送信しました。受信トレイを確認してください。",
  verificationEmailFailed: "確認メールの送信に失敗しました。もう一度お試しください。",
  verifyYourEmail: "メールアドレスを確認",
  verifyEmailInstructions: "アカウントにアクセスするにはメールアドレスを確認してください。受信トレイで確認リンクをご確認ください。",
  sending: "送信中...",
  resendVerificationEmail: "確認メールを再送信",
  login: "ログイン",
  register: "登録",
  home: "ホーム",
  calendar: "カレンダー",
  friends: "友達",
  profile: "プロフィール",
  logout: "ログアウト",
  loading: "読み込み中...",
  language: "言語",
  calendarSelectPlaceSuggestion: "座標を追加するため、候補から場所を選択してください。",
  calendarSelectDateAndTime: "日付と時刻を選択してください。",
  calendarPositiveDuration: "正の時間を入力してください。",
  calendarFutureDateRequired: "イベントの日時は未来である必要があります。",
  calendarCreateEventFailed: "イベントの作成に失敗しました。もう一度お試しください。",
  cancel: "キャンセル",
  createNewEvent: "新しいイベントを作成",
  week: "週",
  month: "月",
  eventTitle: "タイトル",
  date: "日付",
  time: "時刻",
  duration: "時間",
  endsAt: "終了時刻",
  place: "場所",
  searchForPlace: "場所を検索",
  placeSearchTip: "ヒント: 入力を開始し、結果を選択して座標を追加してください。",
  description: "説明",
  createEvent: "イベントを作成",
  today: "今日",
  previousMonth: "前の月",
  nextMonth: "次の月",
  previous: "前へ",
  next: "次へ",
  mondayShort: "月",
  tuesdayShort: "火",
  wednesdayShort: "水",
  thursdayShort: "木",
  fridayShort: "金",
  saturdayShort: "土",
  sundayShort: "日",
  more: "さらに表示",
  mustRespondWillBeforeReposting: "再投稿する前に「参加する」を選択する必要があります",
  event: "イベント",
  backToCalendar: "カレンダーに戻る",
  addToGoogleCalendar: "Googleカレンダーに追加",
  when: "日時",
  where: "場所",
  openLocationInGoogleMaps: "Googleマップで場所を開く",
  hosts: "主催者",
  yourResponse: "あなたの回答",
  currentResponse: "現在の回答",
  response_will: "参加する",
  response_might: "参加するかもしれない",
  response_wont: "参加しない",
  willRunIntoYou: "立ち寄ります",
  mightDropBy: "立ち寄るかもしれません",
  wontCome: "行きません",
  repostToMyFriends: "友達に再投稿",
  responses: "回答",
  willAttend: "参加予定",
  reposted: "再投稿済み",
  mightAttend: "参加するかもしれない",
  cancelEvent: "イベントをキャンセル",
  cancellationEmailNoticeBefore: "参加すると回答した人には",
  cancellationEmailNoticeAfter: "イベントのキャンセル通知メールが送信されます。",
  optionalCancellationMessage: "参加者への任意メッセージ（最大1000文字）",
  confirmCancelEvent: "イベントのキャンセルを確認",
  clear: "クリア",
  confirmCancellation: "キャンセルを確認",
  confirmCancellationMessage: "このイベントを本当にキャンセルしますか？参加確定者に通知され、イベントは削除されます。",
  eventCancelledNotified: "イベントをキャンセルしました。通知先:",
  attendees: "参加者",
  failedToCancelEvent: "イベントのキャンセルに失敗しました",
  back: "戻る",
  cancelled: "キャンセル済み",
  ok: "OK",
  forgotPassword: "パスワードを忘れた",
  email: "メールアドレス",
  passwordResetLinkSent: "アカウントが存在する場合、パスワードリセットリンクを送信しました。",
  passwordResetRequestFailed: "パスワードリセットの要求に失敗しました。",
  sendResetLink: "リセットリンクを送信",
  addFriend: "友達を追加",
  incomingRequests: "受信したリクエスト",
  accept: "承認",
  deny: "拒否",
  myFriends: "友達一覧",
  noFriendsYet: "まだ友達がいません。追加してみましょう！",
  seeProfile: "プロフィールを見る",
  noEventsToRespondTo: "回答が必要なイベントはありません",
  allCaughtUp: "すべて確認済みです。後で友達の新しいイベントを確認してください。",
  events: "イベント",
  unknown: "不明",
  noDescriptionProvided: "説明はありません。",
  will: "参加",
  maybe: "たぶん",
  wont: "不参加",
  userNotFound: "ユーザーが見つかりません",
  friendRequestSentSuccessfully: "フレンドリクエストを送信しました！",
  friendInvitation: "フレンド招待",
  sendFriendRequest: "フレンドリクエストを送信",
  loginToSendFriendRequest: "フレンドリクエストを送信するにはログインしてください",
  chooseLanguage: "言語を選択",
  invalidCredentials: "認証情報が正しくありません。もう一度お試しください。",
  username: "ユーザー名",
  password: "パスワード",
  forgotPasswordQuestion: "パスワードを忘れましたか？",
  dontHaveAccount: "アカウントをお持ちでないですか？",
  registerHere: "こちらで登録",
  invalidProfilePhotoType: "無効なファイル形式です。JPEG、PNG、GIF、またはWebP画像をアップロードしてください。",
  invalidFileExtension: "無効なファイル拡張子",
  allowedExtensions: "許可済み",
  fileTooLarge: "ファイルが大きすぎます",
  maximumFileSize: "最大",
  profilePhotoRemoved: "プロフィール写真を削除しました。",
  failedToRemoveProfilePhoto: "プロフィール写真の削除に失敗しました",
  profileUpdatedSuccessfully: "プロフィールを更新しました！",
  failedToUpdateProfile: "プロフィールの更新に失敗しました",
  privateEmailExplanation: "プラットフォーム外での不要なメッセージを避けるため、あなたのみがメールアドレスを閲覧できます",
  yourEmailIsPrivate: "あなたのメールアドレスは非公開です。",
  profilePhoto: "プロフィール写真",
  removePhoto: "写真を削除",
  firstName: "名",
  lastName: "姓",
  tellPeopleAboutYourself: "自己紹介",
  whereToContactMe: "連絡先",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "保存",
  notSet: "未設定",
  editProfile: "プロフィールを編集",
  imageToCrop: "トリミング画像",
  zoom: "ズーム",
  usePhoto: "写真を使用",
  name: "名前",
  whereToContact: "連絡先",
  removeFriendship: "友達解除",
  confirmRemoveFriend: "友達解除を確認",
  confirmRemoveFriendBefore: "",
  confirmRemoveFriendAfter: "を友達リストから削除してもよろしいですか？",
  friendRemoved: "友達を削除しました。",
  failedToRemoveFriend: "友達の削除に失敗しました。",
  confirmRemove: "削除を確認",
  error: "エラー",
  removed: "削除済み",
  passwordsDoNotMatch: "パスワードが一致しません",
  registrationFailed: "登録に失敗しました。もう一度お試しください。",
  confirmPassword: "パスワード確認",
  alreadyHaveAccount: "すでにアカウントをお持ちですか？",
  loginHere: "こちらからログイン",
  passwordResetSuccessfully: "パスワードをリセットしました。",
  failedToResetPassword: "パスワードのリセットに失敗しました。",
  resetPassword: "パスワードをリセット",
  newPassword: "新しいパスワード",
  confirmNewPassword: "新しいパスワードを確認",
  setNewPassword: "新しいパスワードを設定",
  emailVerifiedSuccessfully: "メールアドレスを確認しました！",
  emailVerificationFailed: "確認に失敗しました。リンクが無効または期限切れの可能性があります。",
  verifying: "確認中...",
  verified: "確認済み！",
  redirectingToHome: "ホームへ移動しています...",
  verificationFailed: "確認に失敗しました",
  goToHome: "ホームへ移動",
  about: "概要",
  aboutConceptTitle: "コンセプト",
  aboutCreatorIntroduction: "こんにちは。ロッククライマーでRun Into Meの制作者、Crypt0です。",
  aboutCreatorStory: "私は人と話すことが好きで、登っている合間にも他のクライマーと話していました。その結果、連絡先が増え、友人とのクライミング予定の調整に多くの時間を使うようになりました。",
  aboutPlanningProblem: "毎回予定を立てて一人ずつ連絡する代わりに、正式に招待せず、いつどこで登るかを全員へ同時に伝えたいと思いました。",
  aboutDeveloperSolution: "そこで、自分が開発者であり、解決策を自分で作れることを思い出しました。",
  aboutWelcome: "Run Into Meへようこそ。友人が気軽に参加できる活動の予定を知らせるためのサイトです。",
  aboutCallToAction: "一人でもできるけれど一緒ならもっと楽しい活動を予定したら、ここに投稿して友人に知らせましょう。",
  aboutTutorialTitle: "チュートリアル",
  aboutCalendarCreateEvent: "カレンダー画面では新しいイベントも作成できます。",
  aboutEventColorsIntroduction: "イベントの色は参加状況を示します。",
  aboutColorGold: "金色",
  aboutColorGoldDescription: "あなたが主催するイベントです。",
  aboutColorGreen: "緑",
  aboutColorGreenDescription: "参加予定のイベントです。",
  aboutColorOrange: "オレンジ",
  aboutColorOrangeDescription: "「未定」と回答しました。",
  aboutColorBlue: "青",
  aboutColorBlueDescription: "まだ回答していません。",
  aboutColorGray: "灰色",
  aboutColorGrayDescription: "招待を辞退しました。",
  aboutCalendarEventDetails: "イベントをクリックすると詳細を確認して回答できます。",
  aboutFriendPageTitle: "友達ページ",
  aboutFriendPageDescription: "ユーザー名を入力するか、招待リンク／QRコードを渡して友達を追加します。",
  aboutHomePageTitle: "ホームページ",
  aboutHomePageDescription: "友達の今後のイベントを確認し、参加するか知らせます。",
  aboutRepostScreenTitle: "再投稿画面",
  aboutGoogleCalendarDescription: "このボタンでイベントをGoogleカレンダーに追加できます。",
  aboutRepostDescription: "参加すると回答したイベントは友達に再投稿できます。",
};

export default ja;